/* eslint-disable */
import React, { useState } from 'react';
import {
  Dialog, Box, Typography, TextField, Button, IconButton, InputAdornment, Divider, CircularProgress,
} from '@mui/material';
import toast from 'Utils/toast';
import copyIcon from 'Images/copy_icon.svg';
import { resetUserPassword } from '../UsersService';

const KeyIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 17.26 17.26">
    <g transform="translate(-548.947 -301.81)">
      <path
        d="M6.678,14.475l1.559-1.559H9.8l1.06-1.06A5.068,5.068,0,1,0,7.741,8.743L2,14.475v3.119H5.119l1.559-1.559Z"
        transform="translate(547.697 300.727)"
        fill="none"
        stroke="#007BC6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.559,6.78A.78.78,0,1,1,16.78,6,.78.78,0,0,1,17.559,6.78Z"
        transform="translate(544.612 299.844)"
        fill="none"
        stroke="#007BC6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

import { generatePassword, inputSx } from './utils';

const ResetPasswordDialog = ({ user, onClose, onSuccess }) => {
  const [password, setPassword] = useState(generatePassword());
  const [copied, setCopied] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(password);
    toast.success('Mot de passe copié');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await resetUserPassword({ code: user?.username, newPassword: password });
      toast.success('Mot de passe réinitialisé avec succès');
      onClose();
      if (onSuccess) onSuccess();
    } catch (e) {
      toast.error(e?.response?.data?.statusLabel || 'Erreur lors de la réinitialisation');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '8px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
          padding: 0,
          overflow: 'hidden',
          marginBottom: '400px',
        },
      }}
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0, 37, 59, 0.28)' } } }}
    >
      <Box sx={{ px: '20px', py: '18px', display: 'flex', flexDirection: 'column', gap: '14px' }}>

        {/* Title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Box sx={{
            width: 34,
            height: 34,
            borderRadius: '50%',
            backgroundColor: 'rgba(0, 123, 198, 0.21)',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >
            <KeyIconSvg />
          </Box>
          <Typography sx={{ fontSize: '18px', fontWeight: 600, color: '#385576' }}>
            Réinitialiser le mot de passe ?
          </Typography>
        </Box>

        {/* Password field */}
        <TextField
          fullWidth
          value={password}
          disabled
          sx={inputSx}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={handleCopy} sx={{ color: '#8397AE' }}>
                  {copied
                    ? <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22C55E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    : <img src={copyIcon} alt="copy" style={{ width: 15, height: 15 }} />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Divider sx={{ my: 0, borderColor: '#F1F5F9', borderBottomWidth: '2px' }} />

        {/* Buttons */}
        <Box sx={{ display: 'flex', gap: '12px' }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              flex: 1,
              height: 44,
              fontWeight: 600,
              fontSize: '14px',
              color: '#385576',
              borderColor: '#E6E7EA',
              borderRadius: '8px',
              textTransform: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
              '&:hover': { borderColor: '#385576', backgroundColor: '#F8FAFC', boxShadow: '0 2px 8px rgba(0,0,0,0.07)' },
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={submitting}
            variant="contained"
            sx={{
              flex: 1,
              height: 44,
              fontWeight: 600,
              fontSize: '14px',
              backgroundColor: '#007BC6',
              color: '#FFFFFF',
              borderRadius: '8px',
              textTransform: 'none',
              boxShadow: '0 2px 8px rgba(0,123,198,0.25)',
              '&:hover': { backgroundColor: '#005F9E', boxShadow: '0 2px 8px rgba(0,123,198,0.25)' },
            }}
          >
            {submitting ? <CircularProgress size={15} sx={{ color: '#fff' }} /> : 'Ok'}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ResetPasswordDialog;